import React, {useEffect, useState} from "react";
import {Badge, Card, Layout} from 'antd';
import Firebase from "../../../Firebase";
import {useListVals} from "react-firebase-hooks/database";
import {MDBBadge, MDBBtn, MDBIcon, MDBListGroup, MDBListGroupItem} from "mdbreact";
import {useAuthState} from "react-firebase-hooks/auth";
import { Menu, Dropdown, Button, Space } from 'antd';
import {PlusOutlined} from "@ant-design/icons";
import Messages from "./Messages";
import FireFetch from "../../FireFetch";



const { Header, Content } = Layout;

const moment = require("moment");
const chatRef = Firebase.database().ref("System/Chats");
const userRef = Firebase.database().ref("System/Users");
const messageRef = Firebase.database().ref("System/Messages");
const ChatList = () => {

    const [chats, loading, error] = useListVals(chatRef);
    const [messages] = useListVals(messageRef);
    const [users] = useListVals(userRef);
    const [userArray, setUserArray] = useState([])
    const [loggedInUser] = useAuthState(Firebase.auth());
    const [chatArray, setChatArray] = useState([]);
    const [showChat, setShowChat] = useState(false);
    const [chatDetails, setChatDetails] = useState(null);
    
    useEffect(() => {
       if(loggedInUser){
           if(users){
               //users.splice(users.findIndex(x => (x.userID) === loggedInUser.uid), 1);
               setUserArray(users.filter(x => x.userID !== loggedInUser.uid));
           }

           if(chats){
               var tempArray = [];
               chats.map((chat) => {


                   if(loggedInUser.uid === chat.users.user1){
                       var filteredArray = messages.filter(x => ((x.chatID === chat.chatID && x.status === "unread" && x.receiver === loggedInUser.uid)));
                       chat.receiverID = chat.users.user2;
                       chat.unread = filteredArray.length;
                       chat.receiver = users[users.findIndex(x => (x.userID) === chat.users.user2)]&&
                           users[users.findIndex(x => (x.userID) === chat.users.user2)].firstname + " " +
                           users[users.findIndex(x => (x.userID) === chat.users.user2)].surname;

                       tempArray.push(chat);
                   } else if(loggedInUser.uid === chat.users.user2){
                       var filters = messages.filter(x => ((x.chatID === chat.chatID && x.status === "unread" && x.receiver === loggedInUser.uid)));
                       chat.unread = filters.length;
                       chat.receiverID = chat.users.user1;
                       chat.receiver = users[users.findIndex(x => (x.userID) === chat.users.user1)]&&
                           users[users.findIndex(x => (x.userID) === chat.users.user1)].firstname + " " +
                           users[users.findIndex(x => (x.userID) === chat.users.user1)].surname;
                       tempArray.push(chat);
                   }

                   tempArray = tempArray.filter((thing, index, self) =>
                       index === self.findIndex((t) => (
                           t.chatID === thing.chatID
                       ))
                   )

                   setChatArray([...tempArray])
                   
               });
           }
           
       }
        
    }, [chats, loggedInUser, users]);

    const menu = (
        <Menu>
            {userArray.map((user, index) => (
                <Menu.Item key={index} onClick={()=>{createChat(user.userID, user.firstname + " " + user.surname)}}>
                    <>
                        {user.firstname + " " + user.surname}
                    </>
                </Menu.Item>
            ))}
        </Menu>
    );

    const createChat = (receiverID, receiverName) => {

        var avIndex = chats.findIndex(x => ((x.users.user1 === loggedInUser.uid)||(x.users.user2 === loggedInUser.uid))
            &&((x.users.user1 === receiverID)||(x.users.user2 === receiverID)))

        var chatty = {
            name : receiverName,
            receiver : receiverID,
        }

        if(avIndex === -1){
            var chatID =  Array(20).fill("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz123456789")
                .map(function(x) { return x[Math.floor(Math.random() * x.length)] }).join('');
            var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");

            chatty.chatID = chatID;

            var object = {
                chatID : chatID,
                dateCreated : timeStamp,
                users : {
                    user1 : loggedInUser.uid,
                    user2 : receiverID
                }
            }


            FireFetch.SaveTODB("Chats", chatID, object).then((result) => {
                if(result === "success"){
                    setChatDetails(chatty);
                    setShowChat(true);
                }
            });


        } else {
            chatty.chatID = chats[avIndex].chatID;
            setChatDetails(chatty);
            setShowChat(true);
        }

    }

    return (
        <>
            {showChat ?
            <Messages chatlist={setShowChat} chatDetails={chatDetails}/> :

                <div className="h-100">
                    <Layout className="h-100">
                        <Header className="text-white d-flex align-items-center justify-content-between">
                            <>Chats</>
                            <Dropdown overlay={menu} placement="bottomRight">
                                <Button className="d-flex justify-content-center align-items-center">
                                    <MDBIcon icon="comment" className="mr-1"/><PlusOutlined />
                                </Button>
                            </Dropdown>
                        </Header>
                        <Content>
                            <Card className="h-100 m-2">
                                <MDBListGroup>
                                    {chatArray.map((chat) => (
                                        <MDBListGroupItem hover onClick={()=>{
                                            setChatDetails({
                                                name : chat.receiver,
                                                receiver : chat.receiverID,
                                                chatID : chat.chatID
                                            })
                                            setShowChat(true)
                                        }} className="mb-1">
                                            <div className="w-100 d-flex justify-content-between">
                                                <h6 className="mb-1">{chat.receiver}</h6>
                                                <Badge count={chat.unread} style={{ backgroundColor: '#52c41a' }}/>
                                            </div>
                                            <small className="text-muted">{moment(chat.dateCreated, "YYYY-MM-DDTh:mm").format("DD MMM YYYY")}</small>

                                        </MDBListGroupItem>
                                    ))}
                                </MDBListGroup>

                            </Card>
                        </Content>

                    </Layout>
                </div>
            }


        </>



    )
}

export default ChatList;